import { Routes } from '@angular/router';

import { authGuard } from './guards/auth/auth.guard';
import { nonAuthGuard } from './guards/non-auth/non-auth.guard';

export const appRoutes: Routes = [
  {
    path: 'news',
    loadChildren: () => import('./pages/news/news.routes').then(m => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [nonAuthGuard]
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/contents/pages.routes').then(m => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/users/users.routes').then(m => m.routes),
    canActivate: [authGuard]
  },
  {
    path: 'folders',
    loadChildren: () => import('./pages/folders/folders.routes').then(m => m.routes),
    canActivate: [authGuard]
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
  },
  {
    path: '503',
    loadComponent: () => import('./pages/server-error/server-error.component').then(m => m.ServerErrorComponent)
  },
  {
    path: '',
    redirectTo: 'news',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full'
  }
];
